import type { TFunction } from "i18next";

type NewsItemField = "title" | "teaser" | "p1" | "p2" | "badgeTitle" | "badgeTeaser";

export function tNewsItem(
  t: TFunction<"news">,
  id: string,
  field: NewsItemField
): string {
  return t(`items.${id}.${field}` as never);
}
